import { Outlet } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { Box, CssBaseline } from "@mui/material";

import SideBar from "./Sidebar";
import AppBar from "./AppBar";
import { useSelector } from "react-redux";

// Page area next to the sidebar (also used by the POS layout).
export const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    backgroundColor: "#f4f7fa",
    flexGrow: 1,
    // marginTop: 100,
    width: "100%",
    minHeight: "calc(100vh - 64px)",
    // flexGrow: 1,
    padding: "16px",
    marginTop: "64px",
    // marginRight: '20px',
    borderRadius: `8px`,
    ...(!open && {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      [theme.breakpoints.up("md")]: {
        marginLeft: -220,
        width: `calc(100% - ${220}px)`,
      },
      // Below md the sidebar is a `temporary` drawer — it overlays the page
      // instead of occupying a column — so the content must NOT reserve its
      // 220px, otherwise every page is squeezed into the leftover sliver.
      [theme.breakpoints.down("md")]: {
        marginLeft: 0,
        marginRight: 0,
        width: "100%",
        padding: "8px",
      },
    }),
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      width: `calc(100% - ${220}px)`,
      // Same as above: the overlay drawer takes no layout space on mobile.
      [theme.breakpoints.down("md")]: {
        marginLeft: 0,
        marginRight: 0,
        width: "100%",
        padding: "8px",
      },
    }),
    // transition: theme.transitions.create("margin", {
    //   easing: theme.transitions.easing.sharp,
    //   duration: theme.transitions.duration.leavingScreen,
    // }),
    // marginLeft: -(260 - 40),
    // ...(open && {
    //   transition: theme.transitions.create("margin", {
    //     easing: theme.transitions.easing.easeOut,
    //     duration: theme.transitions.duration.enteringScreen,
    //   }),
    //   marginLeft: 0,
    // }),
  })
);

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
  const leftDrawerOpened = useSelector((state) => state.app.is_drawer_opened);

  return (
    <Box sx={{ display: "flex" }} dir="rtl">
      <CssBaseline />
      <AppBar />
      <SideBar />
      <Main open={leftDrawerOpened}>
        <Outlet />
      </Main>
    </Box>
  );
};

export default MainLayout;
